import { createContext, type ReactNode, use, useEffect, useState } from 'react';
import { session } from '../../shared/api/session';

const RestoredContext = createContext(false);

/**
 * On load, tries to restore the session from the refresh cookie (so a page reload keeps you signed in),
 * and tells the routes when that first check is over.
 */
export function SessionRestore({ children }: { children: ReactNode }) {
  const [restored, setRestored] = useState(false);

  useEffect(() => {
    let active = true;
    void session.refresh().finally(() => {
      if (active) setRestored(true);
    });
    return () => {
      active = false;
    };
  }, []);

  return <RestoredContext value={restored}>{children}</RestoredContext>;
}

export function useSessionRestored(): boolean {
  return use(RestoredContext);
}
